import { Component } from '@angular/core';

@Component( {
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: [ './contact.component.css' ],
    standalone: false
} )
export class ContactComponent { }
